import React, { Component } from 'react';
import { connect } from 'react-redux';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import Datepicker from "../../common/form/datepicker";
import { getValidOrderDates } from "../../../actions/orders";
import { Information } from '../../common/icons';

class OrderDeliveryDate extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getValidOrderDates());
  }

  validDeliveryDate = (current) => {
    const { validDates } = this.props;

    return validDates.indexOf(current.format("DD/MM/YYYY")) >= 0;
  }

  render() {
    const { deliveryDate } = this.props;

    return(
      <div>
        <span className="information-title">Delivery date (optional)</span>
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip id="tooltip" className="tooltip">
            Delivery date can be any week day up to a month from today. Not including the next 3 working days.
          </Tooltip>}
        >
          <Information className="information-icon" height={12} width={12} />
        </OverlayTrigger>
        <Datepicker
          model="deep.order.confirm.delivery_date"
          value={deliveryDate}
          valid={this.validDeliveryDate} />
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    deliveryDate: state.deep.order.confirm.delivery_date,
    validDates: state.orders.validDates
  };
};

export default connect(mapStateToProps)(OrderDeliveryDate);



// WEBPACK FOOTER //
// ./src/components/new-order/confirm/order-delivery-date.jsx